<template>
  <div>
    <div class="info-head spaceBetween">
      <span>Personal Verification</span>
      <el-button type="text" :icon="isOpen?'el-icon-arrow-up':'el-icon-arrow-down'" @click="isOpen=!isOpen"></el-button>
    </div>
    <div slot="body" v-show="isOpen">
      <component
        :is="areaComp[area]"
        :PersonInfo.sync="PersonInfo"
        :NationalIds.sync="NationalIds"
        :Location.sync="Location"
      ></component>

    </div>
  </div>
</template>

<script>
import CAInfo from "@/views/authentication/IdentityKYC/components/CAInfo.vue";
import CNInfo from "@/views/authentication/IdentityKYC/components/CNInfo.vue";
import HKInfo from "@/views/authentication/IdentityKYC/components/HKInfo.vue";
import USInfo from "@/views/authentication/IdentityKYC/components/USInfo.vue";
export default {
  components: { CAInfo, CNInfo, HKInfo, USInfo },
  props: {
    pageData: {
      type: Object,
      default:()=>{
        return {}
      }
    },
  },
  data() {
    return {
      area: "CA",
      areaComp:{
        "CA":"CAInfo",
        "CN":"CNInfo",
        "HK":"HKInfo",
        "US":"USInfo"
      },
      PersonInfo:{},
      NationalIds:{},
      Location:{},
      isOpen:true
    };
  },
  methods: {
    init() {
      this.area = this.pageData && this.pageData.CountryCode;
      this.PersonInfo = this.pageData && this.pageData.DataFields.PersonInfo;
      let NationalIds = this.pageData && this.pageData.DataFields.NationalIds;
      this.Location = this.pageData && this.pageData.DataFields.Location || {};
      this.Location.Address1 = this.Location.AdditionalFields && this.Location.AdditionalFields.Address1;
      if(this.PersonInfo.YearOfBirth){
        let m = this.PersonInfo.MonthOfBirth < 10 ? ("0" + this.PersonInfo.MonthOfBirth) : this.PersonInfo.MonthOfBirth;
        let d = this.PersonInfo.DayOfBirth < 10 ? ("0" + this.PersonInfo.DayOfBirth) : this.PersonInfo.DayOfBirth;
        this.PersonInfo.Birth = this.PersonInfo.YearOfBirth + "-" + m + "-" + d ;
      }
      if(NationalIds){
        this.NationalIds = NationalIds[0] || {};
      }

    },
  },
  watch: {
    pageData: {
      deep: true,
      handler(newVal) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="scss">
.info-head{
  padding:0.24rem 0.32rem;
  border-bottom:1px solid #F0F0F0;
  font-size: 0.22rem;
  font-weight: bold;
}
</style>
